export default __webpack_public_path__ + "static/media/ic-profile.3ccbc80d.png";